import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgxSpinnerModule, Size } from 'ngx-spinner';
import { SpinnerService } from '../spinner.service';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule, NgxSpinnerModule],
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements OnChanges {
  @Input() fullScreen = true;
  @Input() size: Size = 'medium';
  @Input() viewText = true;
  @Input() icon = 'ball-spin';
  @Input() name = 'full';
  @Input() loadingText = 'Loading...';

  @Input() show: boolean | undefined = false;
  _show: boolean | undefined = false;

  constructor(public spinnerService: SpinnerService) {}

  ngOnChanges(changes: SimpleChanges): void {
    const showSpinnerChange = changes['show'];
    if (showSpinnerChange) {
      if (showSpinnerChange.isFirstChange()) {
        this._show = !this.show;
        setTimeout(() => (this._show = this.show));

        return;
      }

      this._show = this.show;
    }
  }
}
